import { apiClient } from '../utils/apiClient';

export const sendTransactionEmail = async (transactionData: any): Promise<boolean> => {
  try {
    const response = await apiClient.post('/api/enquiry/send-transaction-email', { transactionData });
    return response?.success || false;
  } catch (error) {
    console.error('Error sending transaction email:', error);
    return false;
  }
};

export const sendPrivateOfficeEnquiry = async (enquiryData: any): Promise<boolean> => {
  try {
    const response = await apiClient.post('/api/enquiry/private-office-enquiry', enquiryData);
    return response?.success || false;
  } catch (error) {
    console.error('Error sending private office enquiry:', error);
    return false;
  }
};
